// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1xZhw","title":"Card_title__26xXk","year":"Card_year__2SaZ9","Avatar":"Card_Avatar__1apK_"};